<template>
  <div>
    <el-dialog
      :top="top"
      :close-on-click-modal="false"
      :close-on-press-escape="isAllowEscClose"
      :fullscreen="fullscreen"
      :visible.sync="dialogVisible"
      :width="`${width}px`"
      :style="{ height: `${height}px` }"
      :append-to-body="true"
      :show-close="false"
      custom-class="recombination"
      :before-close="handleClose"
      @close.native="handleClose"
    >
      <div :class="fullscreen?'recombination_box':''" class="w100" style="display: -webkit-box">
        <!-- 弹窗部分 -->
        <div class="recombination_left flex_grow flex_between_start flex_column w100">
          <div class="recombination_header">
            <el-link v-if="iconFlag" :underline="false" :disabled="btnPrev?false:true" @click="handleArrowUp">
              <el-tooltip class="item" effect="dark" content="上一个记录" placement="top-start">
                <i class="el-icon-arrow-left recombination_icon"></i>
              </el-tooltip>
            </el-link>
            <el-link v-if="iconFlag" :underline="false" :disabled="btnNext?false:true" @click="handleArrowDown">
              <el-tooltip class="item" effect="dark" content="下一个记录" placement="top-start">
                <i class="el-icon-arrow-right recombination_icon"></i>
              </el-tooltip>
            </el-link>
            <el-link v-if="iconFlag" :underline="false" @click="handleArrowReresh">
              <el-tooltip class="item" effect="dark" content="刷新" placement="top-start">
                <i class="el-icon-refresh-right recombination_icon"></i>
              </el-tooltip>
            </el-link>
            <span>{{ title }}</span>
            <span>
              <slot name="title-wrapper"></slot>
            </span>
          </div>
          <div class="recombination_body flex_grow">
            <slot name="body"></slot>
          </div>
          <div slot="footer" class="dialog-footer w100">
            <slot name="footer"></slot>
          </div>
        </div>
        <!-- 右侧历史记录 -->
        <div :class="className">
          <div class="header flex_end_center">
            <el-link v-if="iconFlag" :underline="false" @click="handleFullScreen">
              <el-tooltip class="item" effect="dark" content="全屏" placement="top-start">
                <i class="el-icon-full-screen recombination_icon"></i>
              </el-tooltip>
            </el-link>
            <el-link :underline="false" @click="handleClose">
              <el-tooltip class="item" effect="dark" content="关闭" placement="top-start">
                <i class="el-icon-close recombination_icon"></i>
              </el-tooltip>
            </el-link>
          </div>
          <el-tabs v-if="isShowLog" v-model="activeTabName" v-trim class="tabsbox">
            <el-tab-pane v-if="isUseDefaultOprLog" :label="'操作日志('+total+')'" name="operationLog">
              <div style="max-height:80vh; overflow: auto;">
                <div v-for="(item,index) in list" :key="index" class="mg_10_0 logBox">
                  <div>
                    <span class="fz-s primarycolor logUser">{{ item.user_name }}</span>
                    <span class="fz-s color7f">{{ item.operation_log }}</span>
                  </div>
                  <span class="fz-s coloraaa flex_end_center">{{ parseTime(item.operation_date_time) }}</span>
                </div>
              </div>
              <pagination v-show="total>0" :total="total" :page.sync="listQuery.page_no" :limit.sync="listQuery.page_size" layout="prev, pager, next, jumper" @pagination="getList" />
            </el-tab-pane>
            <slot v-else name="tab_body"></slot>
          </el-tabs>
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import { logList } from '@/api/log'
import { parseTime, amountFormat } from '@/utils/index'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination

export default {
  name: 'Recombination',
  components: { Pagination },
  provide() {
    return {
      parentVm: this
    }
  },
  props: {
    width: {
      type: [Number, String],
      default: 1000
    },
    height: {
      type: [Number, String]
    },
    top: {
      type: String,
      default: '15vh'
    },
    // 弹窗title
    title: {
      type: String,
      default: ''
    },
    slotTitle: {
      type: String,
      default: ''
    },
    // 是否显示Log
    isShowLog: {
      type: Boolean,
      default: false
    },
    // log 的type
    type: {
      type: String
    },
    // log 的id
    id: {
      type: [Number, String]
    },
    // 左右按钮是否可以点击
    btnNext: {
      type: Boolean,
      default: false
    },
    btnPrev: {
      type: Boolean,
      default: false
    },
    iconFlag: {
      type: Boolean,
      default: true
    },
    // log 的type
    activeName: {
      type: String,
      default: 'operationLog'
    },
    // 是否允许按下esc关闭dialog
    isAllowEscClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      fullscreen: false,
      list: [],
      listQuery: {
        page_size: 20,
        page_no: 1
      },
      total: 0,
      show: true,
      className: '',
      activeTabName: this.activeName, // 激活的默认标签显示的字段
      isUseDefaultOprLog: true, // 是否默认使用操作日志
      isClose: false
    }
  },
  watch: {
    dialogVisible(val, oldVal) {
      this.activeTabName = this.activeName
      if (val) {
        const slotNameArr =
          this.$slots['tab_body'] &&
          this.$slots['tab_body']
            .filter((el) => el.tag)
            .map((item) => item['componentOptions']['propsData']['name'])
        this.isUseDefaultOprLog = !!(
          !slotNameArr ||
          slotNameArr.length <= 0 ||
          (slotNameArr &&
            slotNameArr.length > 0 &&
            slotNameArr.indexOf('operationLog') < 0)
        )
      }
    },
    id(val, oldVal) {
      // 普通的watch监听
      this.$nextTick(() => {
        this.listQuery.key = this.id
        if (this.id && this.isShowLog && this.isUseDefaultOprLog) {
          this.getList()
        }
      })
    },
    iconFlag(val, oldVal) {
      this.$nextTick(() => {
        if (this.isShowLog) {
          this.className = 'recombination_right_isShowLog'
        } else if (this.iconFlag) {
          this.className = 'recombination_right_haveicon'
        } else {
          this.className = 'recombination_right'
        }
      })
    },
    isShowLog(val, oldVal) {
      this.$nextTick(() => {
        if (this.isShowLog) {
          this.className = 'recombination_right_isShowLog'
        } else if (this.iconFlag) {
          this.className = 'recombination_right_haveicon'
        } else {
          this.className = 'recombination_right'
        }
      })
    }
  },
  created() {
    if (this.id && this.isShowLog && this.isUseDefaultOprLog) this.getList()
    document.onkeydown = (e) => {
      // 事件对象兼容
      const e1 =
        e || event || window.event || arguments.callee.caller.arguments[0]
      // 键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
      // 左
      if (e1 && e1.keyCode == 37) {
        // 左
        if (this.btnPrev) {
          this.handleArrowUp()
        }
      } else if (e1 && e1.keyCode == 39) {
        // 右
        if (this.btnNext) {
          this.handleArrowDown()
        }
      }
    }
    this.$nextTick(() => {
      if (this.isShowLog) {
        this.className = 'recombination_right_isShowLog'
      } else if (this.iconFlag) {
        this.className = 'recombination_right_haveicon'
      } else {
        this.className = 'recombination_right'
      }
    })
  },
  methods: {
    // 弹窗打开
    handleOpenDialog() {
      this.dialogVisible = true
    },
    // 上一个方法暴露
    handleArrowUp() {
      this.$emit('handleArrowUp')
    },
    // 下一个方法暴露
    handleArrowDown() {
      this.$emit('handleArrowDown')
    },
    // 刷新
    handleArrowReresh() {
      this.$emit('handleArrowReresh')
    },
    // 全屏
    handleFullScreen() {
      this.fullscreen = !this.fullscreen
    },
    // 关闭弹框
    handleClose() {
      this.isClose = true
      this.dialogVisible = false
      this.$emit('handleBeforeClose')
    },
    handleClose1() {
      console.log('1')
    },
    // // 关闭弹框前事件
    // handleBeforeClose() {
    //   this.$emit('handleBeforeClose')
    // },
    getList() {
      this.listLoading = true
      this.listQuery.operation_name = this.type
      this.listQuery.key = this.id
      logList(this.listQuery).then((response) => {
        this.listLoading = false
        if (response.data.res_status_code == 0) {
          this.list = response.data.res_content.data_list
          this.total = response.data.res_content.total_count
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    parseTime,
    amountFormat
  }
}
</script>
<style lang="scss">
.recombination {
  // height: 100%;
  .recombination_icon {
    font-size: 20px;
    margin: 0 5px;
    // cursor: pointer;
  }
  .recombination_icon:hover {
    // color: #4d939f;
  }
  .recombination_header {
    color: #303133;
    span {
      font-size: 18px;
    }
  }
  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    padding: 0;
  }
  .recombination_box {
    width: 100%;
    height: 100%;
    background-color: white;
  }
  .recombination_left,
  .recombination_right,
  .recombination_right_haveicon {
    padding: 20px 10px;
  }
  .recombination_left {
    .dialog-footer {
      z-index: 100;
      padding: 0 10px 0 0;
      position: relative;
    }
  }
  .recombination_right {
    margin: 0 0 0 -64px;
  }
  .recombination_right_isShowLog {
    width: 240px;
    background: #f9f9f9;
    .el-pagination__jump {
      margin: 0;
    }
    .header {
      padding: 20px 10px;
    }
  }
  .recombination_right_haveicon {
    margin: 0;
    position: absolute;
    right: 10px;
  }

  .recombination_body {
    padding: 10px;
    width: 99%;
  }
  .logUser {
    margin: 0 5px 0 0;
  }
  .logBox {
    border-bottom: 1px solid #ddd;
    padding: 5px 0;
  }
  .pagination-container {
    background: transparent;
    padding: 0 !important;
  }
  .tabsbox {
    padding: 0 10px 10px 10px;
  }
  .recombination_body .el-form-item--mini.el-form-item {
    margin: 0 0 14px 0;
  }
}

// .el-dialog.recombination {
//   /deep/ .el-dialog__header {
//     padding: 0;
//   }
// }
</style>
